import {Observable, Subscription} from 'rxjs';

import ISolution from '../Interfaces/ISolution';

// NB: Both chrome and safari prefer that we push the next play attempt off the
// current stack, and so seem to permit playback (when muted) after a short delay
// here. 50ms was chosen as an arbitrary value that worked while being quick enough
// not to cause a visible delay to the user.

const WAIT_BEFORE_RETRY_DELAY = 50;

const subscribeToForceMuted = (
    forceMuted$: Observable<void>,
    solution: ISolution
): Subscription =>
    forceMuted$
        .subscribe(() => {
            setTimeout(() => solution.play(), WAIT_BEFORE_RETRY_DELAY);
        });

export default subscribeToForceMuted;